<template>
    <div
        class="flex flex-col items-stretch gap-6 p-4 lg:h-full lg:flex-row lg:overflow-x-auto lg:overflow-y-hidden"
    >
        <WorldOverviewSidebar />
        <Suspense>
            <WorldOverviewTiles />
            <template #fallback>
                <div class="w-full">
                    <UiLoader />
                </div>
            </template>
        </Suspense>
    </div>
</template>